import {q, byClassAll, byClass} from "./dom-utils";
import {debounce, throttle} from "./decorators";

const uaRegexp = /(MSIE|(?!Gecko.+)Firefox|(?!AppleWebKit.+Chrome.+)Safari|(?!AppleWebKit.+)Chrome|AppleWebKit(?!.+Chrome|.+Safari)|Gecko(?!.+Firefox))(?: |\/)([\d\.apre]+)/
const _matches = uaRegexp.exec(navigator.userAgent)
const browserName = _matches && _matches[1]
const isSafari = "Safari" === browserName
const isFirefox = "Firefox" === browserName
const isMac = navigator.platform === "MacIntel"

const transitionMs = 800
const throttleMs = transitionMs + (isFirefox ? 2000 : 300)

/**
 * Calc gradients powers based on screen space taken
 * Select active sections and two adjacent sections
 * Render them into layers and layer styling
 * When setting new layers – dispose obsolete ones
 */


function injectBacklight(id, sections, hostElement) {
    const backlight = document.createElement('div')
    backlight.id = id
    backlight.className = 'page3__backlight backlight'
    const layers = sections.map((x) => {
        return `<div id='${id + "-" + x.dataset.dynBgId}' class='backlight__layer'></div>`
    }).join('\n')
    backlight.innerHTML = `
        ${layers}
        <style>
        .backlight {
            position: fixed;
            top: 0; bottom: 0; left: 0; right: 0;
        }
        .backlight__layer { 
            position: absolute;
            top: 0; bottom: 0; left: 0; right: 0;
            transition: opacity ${transitionMs}ms linear;
            opacity: 0; will-change: opacity;
        }
        </style>
        <style></style>
    `;
    hostElement.prepend(backlight)
    return backlight
}

function stampIds(observedElements) {
    observedElements.forEach((el, i) => el.dataset.dynBgId = `dbg-${i}`)
}


/**
 * Calc how much % of screen space each section takes, to determine
 * the strength of its influence on the background gradient
 */
function calcSectionsPowerAndGradients(windowHeight, sectionsInView, scrollTop) {
    const wTopBorder              = scrollTop
    const wLowBorder              = wTopBorder + windowHeight
    return sectionsInView.map((section) => {
        const cr = section.getBoundingClientRect()
        const sectionHeight       = cr.height
        const sectionTop          = cr.y + scrollTop
        const sectionBottom       = sectionTop + sectionHeight

        const stop_cbot_diff      = wLowBorder - sectionTop
        // distance between section top border and window's lower border
        // if this is negative – then the section isn't in the view yet

        const sbot_ctop_diff      = wTopBorder - sectionBottom
        // distance between section lower border and window's top border
        // if this is positive – then the section is out of the already

        const visiblePartStart    = Math.max(sectionTop, wTopBorder)
        const visiblePartEnd      = Math.min(sectionBottom, wLowBorder)
        const visiblePixels       = visiblePartEnd - visiblePartStart
        // const shareOfScreen       = Math.round(1000 * visiblePixels / windowHeight) / 1000
        const shareOfScreen       = Math.round(1000 * visiblePixels / sectionHeight) / 1000

        return {
            sectionId        : section.dataset.dynBgId,
            top              : sectionTop,
            height           : sectionHeight,
            visiblePixels    : visiblePixels,
            power            : shareOfScreen > 0.5 ? 1 : 0,
            gradient         : section.dataset.gradient
        }
    })
}


function sectionCss(layerIdPrefix, { sectionId, power, gradient }) {
    return `
        #${layerIdPrefix}-${sectionId} {
            opacity: ${Math.max(power, 0)};
            background: ${gradient || "none"};
        }
    `
}

function setGradients(layerIdPrefix, backlightElem, activeSectionsData) {
    const sectionsConf = JSON.stringify(activeSectionsData.map((x) => x.power))
    if (backlightElem.dataset.conf === sectionsConf) {
        console.debug("skipping gradients set cause conf if the same")
        return
    }

    console.debug("setting gradients")
    backlightElem.dataset.conf    = sectionsConf
    const children                = Array.from(backlightElem.children)
    const sectionsCount           = activeSectionsData.length
    const dynStyleIdx             = sectionsCount + 1
    const backlightStyle          = children[dynStyleIdx]
    const newStyle                = backlightStyle.cloneNode()
    const layersCss = activeSectionsData.map(s => sectionCss(layerIdPrefix, s)).join('\n')
    newStyle.innerHTML            = layersCss
    requestAnimationFrame(() => {
        backlightElem.append(newStyle)
        setTimeout(() => {
            requestAnimationFrame(() => {
                backlightElem.children[dynStyleIdx].remove()
            })
        }, transitionMs + 30)
    })
}

function setAll(backlightElements, sectionsToRender) {
    backlightElements.forEach(backlightElem => {
        setGradients(backlightElem.id, backlightElem, sectionsToRender)
    })
}

function calcAndSet_({ scrollTop, windowHeight, backlightElements, sections }) {
    const sectionsToRender   = calcSectionsPowerAndGradients(windowHeight, sections, scrollTop)
    // console.log(sectionsToRender)
    setAll(backlightElements, sectionsToRender)
}

const calcAndSet = debounce(calcAndSet_, throttleMs)
export function initDynamicBackground() {
    console.debug('initDynamicBackground')
    if (isSafari && isMac) { return }

    const sectionsHost = byClass('sections')
    if (sectionsHost) {
        sectionsHost.style.background = ""
    }

    const observedElements     = Array.from(byClassAll('section'))
    stampIds(observedElements)
    const windowHeight         = window.innerHeight
    const scrolledElement      = document.scrollingElement
    const backlightElem        = injectBacklight('page-bl', observedElements, q('.page3'))
    const backlightElem2       = injectBacklight('nav-bl', observedElements, q('.top-nav'))
    window.addEventListener('scroll', (e) => {
        const scrollTop        = (e.target.scrollingElement || scrolledElement).scrollTop
        calcAndSet({
            backlightElements: [backlightElem2, backlightElem],
            scrollTop, windowHeight, sections: observedElements
        })
    })
    calcAndSet({
        backlightElements: [backlightElem2, backlightElem],
        scrollTop: scrolledElement.scrollTop,
        windowHeight, sections: observedElements
    })
}